//TODO Export from CommonAngular
export class SelectTreeItem {
    constructor(public id: any, public label: string, public options: SelectTreeItem[]) {}
}